import Image from 'next/legacy/image';
import React from 'react';
import { StarIcon } from '@heroicons/react/solid';
import { useDrawer } from '../Drawer';
import { StaticImageData } from 'next/image';
import Cookies from 'js-cookie';

interface TopCardProps {
  company: string;
  battery: string;
  rating: string;
  image: StaticImageData;
  capacity: string;
  warranty: string;
  bestSeller: boolean;
}

const TopCard: React.FC<TopCardProps> = (props) => {
  const { toggle } = useDrawer();
  const handleGetQuoteClick = () => {
    Cookies.set('sid', 'top-card-quote');
    toggle?.();
  };

  return (
    <div
      className="bg-white border-2 border-primary rounded-md w-40 cursor-pointer md:pointer-events-auto pointer-events-none"
      onClick={handleGetQuoteClick}
    >
      {props.bestSeller ? (
        <div className="mx-auto w-2/3 rounded-b-md bg-primary pb-1 m-0">
          <p className="text-center text-white m-0 text-sm">Best Seller</p>
        </div>
      ) : (
        <div className="mt-6"></div>
      )}

      <div className="flex flex-row justify-between px-4 py-2">
        <div className="flex flex-col text-left">
          <p className="font-medium text-black m-0">{props.company}</p>
          <p className="text-black m-0 text-xs ">{props.battery}</p>
          <div className="flex items-center">
            {[0, 1, 2, 3, 4].map((count) => (
              <StarIcon
                key={count}
                className="text-yellow-400"
                aria-hidden="true"
              />
            ))}
            <p className="font-medium text-black  m-0  pl-1 text-xs">
              {props.rating}
            </p>
          </div>
        </div>
      </div>
      <div className="w-5/6 mx-auto">
        <Image
          src={props.image}
          width={50}
          height={50}
          layout="responsive"
          alt="Battery"
        />
      </div>
      <div className="flex flex-col px-4 py-2">
        <div className="flex flex-row justify-between ">
          <p className="text-black  m-0 text-sm">Capacity</p>
          <p className="text-black font-medium m-0 text-sm ">
            {props.capacity}
          </p>
        </div>
        <div className="flex flex-row justify-between">
          <p className="text-black  m-0 text-sm">Warranty</p>
          <p className="text-black font-medium m-0 text-sm">{props.warranty}</p>
        </div>
      </div>
      <button
        className="bg-primary-500 text-white font-medium w-full p-1 md:pointer-events-auto pointer-events-auto"
        onClick={(e) => {
          e.stopPropagation();
          handleGetQuoteClick();
        }}
      >
        Get Quote
      </button>
    </div>
  );
};

export default TopCard;
